// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3u5Wl","col":"styles_col__3Kb50"};